'use strict'

cpntMap.set('awe-errmon', {
  props: {},
  data: function() {
    return {
      err: null,
      i18n: this.$root.i18n,
    }
  },
  emits: ['widget-close'],
  methods: {
    show: function(err) {
      this.err = err
    },

    close: function() {
      this.$emit('widget-close')
    },

    // clear current error, unless it really is unrecoverable
    clear: function() {
      if (this.err === ErrorCodes.INVALID_TOUCHPOINT_ERROR || this.err === ErrorCodes.DISABLED_ERROR)
        return

      this.err = null
    }
  },
  template: `
    <div v-if="err" id="errMon" :class="err" role="presentation">
      <div id="err-overlay" role="presentation"></div>
      <div id="err-msg" role="alert">{{i18n.getString(err)}}</div>

      <button id="err-close" @click="close" role="button"
        :aria-label="i18n.getString('CLOSE_WIDGET')"
      >
      {{i18n.getString('CLOSE')}}
      </button>

      
    </div>
  `
})
